import React from 'react';
import { itemSelection } from '../../models/itemSelection.model';
import EntitiesSettings from './index';

interface TicketEntitiesProps {
  setBlockScreen: (p: boolean) => void
}

const TicketEntities: React.FC<TicketEntitiesProps> = ({
  setBlockScreen
}) => {

  const options: itemSelection[] = [
    { 'id': 'title', 'label': 'Títulos' },
    { 'id': 'priority', 'label': 'Prioridades' },
    { 'id': 'status', 'label': 'Estados' },
    { 'id': 'closing_cause', 'label': 'Causas de Cierre' },
  ]

  return (
    <React.Fragment>
      <EntitiesSettings
        setBlockScreen={setBlockScreen}
        entity_type='ticket'
        options={options}
      />
    </React.Fragment>
  )
}

export default TicketEntities;